<template>
  <v-card class="mb-4" variant="flat">
    <v-tabs
      :model-value="activeTab"
      color="secondary"
      slider-color="secondary">
      <v-tab
        :to="{ name: 'eds-search-attribute' }"
        replace
        value="attribute">
        <v-icon class="mr-2" icon="mdi-tune-variant" size="18"></v-icon>
        Атрибутивний пошук
      </v-tab>
      <v-tab
        :to="{ name: 'eds-search-full-text' }"
        replace
        value="full-text">
        <v-icon class="mr-2" icon="mdi-format-text" size="18"></v-icon>
        Повнотекстовий пошук
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

defineOptions({
  name: 'SearchTabs',
})

const route = useRoute()

const activeTab = computed(() => {
  return route.name === 'eds-search-full-text' ? 'full-text' : 'attribute'
})
</script>
